<template>
  <div class="Echarts">
    <div id="chart" style="margin-top: 20px;width: 100%;height:420px;"></div>
  </div>
</template>

<script>
import { formatNumberRgx2 } from "@/utils/utils";
export default {
  name: 'Echarts',
  props: {
    leftSeriesData: {
      type: Array,
      required: true
    },
    dateData: {
      type: Array,
      required: true
    },
    legendData: {
      type: Array,
      required: true
    },
    chartTitle: {
      type: String,
      required: false
    },
    pageType: {
      type: String,
      required: true
    }
  },
  computed: {
    options() {
      const { dateData, leftSeriesData } = this;
      const _dateData = dateData && dateData.length ? [...new Set(dateData)].filter(Boolean) : [];
      const series = leftSeriesData.map(t => {
        const td = t.data;
        const data = _dateData.map(d => {
          const _data = td.find(o => o.date === d);
          return _data ? _data.data : 0;
        })
        return Object.assign(t, {
          data
        });
      })
      var colors = ['#3FA7DC', '#FE9400', '#FB6260', '#409EFF', '#51D351']
      var option = {
        color: colors,
        title: {
          show: this.leftSeriesData.length,
          text: '显示TOP 5',
          top: 0,
          padding: [0, 80],
          textStyle: {
            color: "#333",
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const axisValueLabel = params[0].axisValueLabel
            let src = axisValueLabel + '<br>';
            for (const x in params) {
              let value = null
              if (params[x].seriesName && params[x].seriesName.includes('率')) {
                value = `${formatNumberRgx2(params[x].value * 100)} %`
              } else {
                value = params[x].value
              }
              src += params[x].marker + params[x].seriesName + ": " + value + '<br>';
            }
            return src
          }
        },
        grid: {
          y2: 77,
          right: 180
        },
        legend: {
          padding: [0, 20],
          itemGap: 20
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              rotate: 0,
              formatter: function(params) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 11;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName
              }
            },
            data: _dateData
          }
        ],
        yAxis: {
          type: 'value',
          // min: 0,
          // max: that.legendData[0] && that.legendData[0].includes('率') ? this.leftSeriesData && this.leftSeriesData.length ? 1 : 0 : this.hanleNum(Math.max(...this.leftSeriesData) || 10),
          splitNumber: 5,
          // interval: that.legendData[0] && that.legendData[0].includes('率') ? this.leftSeriesData && this.leftSeriesData.length ? 0.2 : 0 : this.hanleNum(Math.max(...this.leftSeriesData) || 10) / 5,
          position: 'left',
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: series
      };
      return option
    }
  },
  methods: {
    hanleNum(n) {
      return (Math.floor(n / 5) + 1) * 5
    },
    myEcharts() {
      var myChart = this.$echarts.init(document.getElementById('chart'));
      this.myChart = myChart;
      myChart.setOption(this.options);
      window.addEventListener('resize', function() {
        myChart.resize();
      });
    }
  },
  mounted() {
    this.myEcharts();
  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        if (this.myChart) {
          if (newVal) {
            this.myChart.clear();
            this.myChart.setOption(newVal)
          } else {
            this.myChart.setOption(oldVal)
          }
        } else {
          this.myEcharts()
        }
      }
    },
    deep: true
  }
}
</script>

<style lang="less" scoped>
.Echarts{
  position: relative;
}
</style>
